import { dispatchersStatementsHeader, dispatchersStatementsHeaderUser } from "@/constants/defaultHeader";
import { httpClient } from "@/services";

export default {
	state: {
		statementsList: [],
		listInfoLoads: [],
		filterLoads: {},
		statementsFilter: {},
		statementsSettingsDefault: null,
		statementsSettings: null,
		statementsHeaders: [],
	},
	getters: {
		statementsFilter(state) {
			return state.statementsFilter;
		},
		getStatementsList(state) {
			return state.statementsList;
		},
		getInfoList(state) {
			return state.listInfoLoads;
		},
		getFilterLoads(state) {
			return state.filterLoads;
		},
		statementsSettingsDefault: s => s.statementsSettingsDefault,
		statementsSettings: s => s.statementsSettings,
		statementsHeaders: s => s.statementsHeaders,
	},
	mutations: {
		updateStatementsSettingsAll(state, payload) {
			state.statementsSettings = state.statementsSettings.map(item => {
				item.settings = payload;
				return item;
			});
		},
		updateStatementsSettingsReset(state) {
			state.statementsSettings = state.statementsSettingsDefault.map(item => ({ ...item }));
		},
		SET_DISPATCHERS_STATEMENTS(state, payload) {
			state.statementsList = payload.statement;
			state.statementsFilter = payload.filter;

			const { statement, filter, settings } = payload;
			state.statementsList = statement;
			state.statementsFilter = filter;

			if (settings && settings.length > 0) {
				state.statementsSettingsDefault = settings;
				// state.statementsSettings = settings.map(item => ({ ...item }));
				state.statementsHeaders = [];
				settings.map(item => {
					if (item.settings) {
						state.statementsHeaders.push(item);
					}
				});
			} else {
				state.statementsSettingsDefault = dispatchersStatementsHeader;
				state.statementsSettings = dispatchersStatementsHeader.map(item => ({ ...item }));
				state.statementsHeaders = [];
				dispatchersStatementsHeader.map(item => {
					if (item.settings) {
						state.statementsHeaders.push(item);
					}
				});
			}
		},
		SET_DISPATCHERS_STATEMENTS_USER(state, payload) {
			state.statementsList = payload.statement;
			state.statementsFilter = payload.filter;

			const { statement, filter, settings } = payload;
			state.statementsList = statement;
			state.statementsFilter = filter;

			if (settings && settings.length > 0) {
				state.statementsSettingsDefault = settings;
				// state.statementsSettings = settings.map(item => ({ ...item }));
				state.statementsSettings = settings
					.filter(item => item.text !== "Dispatcher")
					.map(item => ({ ...item }));
				state.statementsHeaders = [];
				settings.map(item => {
					if (item.settings) {
						state.statementsHeaders.push(item);
					}
				});

			} else {
				state.statementsSettingsDefault = dispatchersStatementsHeaderUser;
				state.statementsSettings = dispatchersStatementsHeaderUser.map(item => ({ ...item }));
				state.statementsHeaders = [];
				dispatchersStatementsHeaderUser.map(item => {
					if (item.settings) {
						state.statementsHeaders.push(item);
					}
				});
			}
		},
		GET_LIST_INFO(state, payload) {
			state.listInfoLoads = payload.loads;
			state.filterLoads = payload.filter;
		},
		DELETE_ITEM(state, payload) {
			state.statementsList = state.statementsList.filter(e => e.id != payload);
		}
	},
	actions: {
		async onStatementsSettingsSave({ dispatch, state }) {
			dispatch("actionPreloader", true);
			try {
				await httpClient.post('/dispatcher/statement/settings', { settings: state.statementsSettings });
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		onStatementsSettingsAll({ commit }, payload) {
			commit('updateStatementsSettingsAll', payload);
		},
		onStatementsSettingsReset({ commit }) {
			commit('updateStatementsSettingsReset');
		},
		async updateStatementFilter({ commit, dispatch }, value) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.post(`/dispatcher/statement/list`, value);

				if (data) {
					commit('SET_DISPATCHERS_STATEMENTS', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async updateStatementFilterUser({ commit, dispatch }, value) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.post(`/dispatcher/statement/list`, value);

				if (data) {
					commit('SET_DISPATCHERS_STATEMENTS_USER', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getListOfStatements({ commit, dispatch }) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.get("dispatcher/statement");

				if (data) {
					commit('SET_DISPATCHERS_STATEMENTS', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getListOfStatementsUser({ commit, dispatch }) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.get("dispatcher/statement");

				if (data) {
					commit('SET_DISPATCHERS_STATEMENTS_USER', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async getListInfo({ commit, dispatch }, payload) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.get(`dispatcher/statement/${ payload }`);

				if (data) {
					commit('GET_LIST_INFO', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async updateFilterLogs({ commit, dispatch }, value) {
			const { id, filter } = value;
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.post(`dispatcher/statement/${ id }/list`, filter);

				if (data) {
					commit('GET_LIST_INFO', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async deleteStatement({ commit, dispatch }, value) {
			const { id } = value;
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.delete(`dispatcher/statement/${ id }`);

				commit('DELETE_ITEM', value);
				if (data) {
					dispatch('getListOfStatements');
					dispatch("actionPreloader", false);
					dispatch("setAlert", {
						type: "success",
						message: "Delete success",
					});
				} else {
					dispatch("actionPreloader", false);
					dispatch("setAlert", {
						type: "error",
						message: "Delete error",
					});
				}
			} catch (e) {
				console.error(e);
			}
		},
	}
};
